import { SORT_ORDER } from '@/shared/constants/sort/sortOrder'
import { SORT_DIRECTION } from '@/shared/constants/sort/sortDirection'

const DEFAULT_STATE = {
  id: null,

  items: [],
  page: 1,
  total: 10,
  limit: 10,

  range: [],
  sorting: {
    sort_by: SORT_ORDER.CREATED_AT,
    sort_direction: SORT_DIRECTION.DESC,
  },

  formData: null,
  loading: false,
  actionLoading: false,
}

export default {
  ...DEFAULT_STATE,
}
